import { useEffect } from "react";
import { create } from "zustand";
import { shallow } from "zustand/shallow";
import { useAuthStore } from "./authStore";
import { LeaderboardClusterData } from "../queries/leaderboard.types";
import { useLeaderboardClustersQuery } from "../queries/widgets";


type LeaderboardClusterActions = {
  readonly setCurrentCluster: (props?:LeaderboardClusterData) => void
  readonly setAvailableClusters: (props: LeaderboardClusterData[]) => void
}

type LeaderboardClusterStore = {
    currentCluster?: LeaderboardClusterData,
    availableClusters: LeaderboardClusterData[]
}


export const useLeaderboardClusterStore = create<LeaderboardClusterStore & LeaderboardClusterActions>((set) => ({
  availableClusters: [],
  setCurrentCluster:(cluster?: LeaderboardClusterData) => set({ currentCluster: cluster }),
  setAvailableClusters: (clusters: LeaderboardClusterData[]) => set({ availableClusters: clusters })
}));

export const useCurrentLeaderboardCluster = () => {
  const { currentCluster, availableClusters, setAvailableClusters, setCurrentCluster } = useLeaderboardClusterStore();
  const enableLeadeboardFlag = useAuthStore(state => state.smartConfiguration?.leaderboard, shallow);
  const { data, isLoading, error } =  useLeaderboardClustersQuery({ enabled: enableLeadeboardFlag });
  useEffect(() => {
    if(!currentCluster && availableClusters.length === 0 && (data?.output?.length ?? 0) > 0) {
      setAvailableClusters(data?.output.map(({ cluster }) => cluster)??[]);
      setCurrentCluster(data?.output?.[0].cluster);
    }
  }, [data, currentCluster, availableClusters, setAvailableClusters, setCurrentCluster]);
  return { isLoading, error, availableClusters, currentCluster };
};
